import { EDGE_THRESHOLD_PX } from 'containers/ForecastDataVisualizer/GraphTooltips/GraphVerticalBar/GraphVerticalBar';

/**
 * Horizontal position of the tooltip pill's left edge so it stays in the graph and
 * stays centered on the scrub line when possible (Figma-aligned edge padding).
 */
export function clampTooltipLeftPx(
  containerWidth: number,
  pillWidth: number,
  scrubCenterX: number,
  edgePadPx: number = EDGE_THRESHOLD_PX,
): number {
  if (containerWidth <= 0) return scrubCenterX;
  if (pillWidth <= 0) return scrubCenterX;

  const half = pillWidth / 2;
  const minLeft = edgePadPx;
  const maxLeft = Math.max(minLeft, containerWidth - edgePadPx - pillWidth);
  const idealLeft = scrubCenterX - half;
  return Math.min(Math.max(idealLeft, minLeft), maxLeft);
}
